import { css } from 'styled-components';

import Inter100NormalTrueType from "./inter-100-normal.ttf";
import Inter200NormalTrueType from "./inter-200-normal.ttf";
import Inter300NormalTrueType from "./inter-300-normal.ttf";
import Inter400NormalTrueType from "./inter-400-normal.ttf";
import Inter500NormalTrueType from "./inter-500-normal.ttf";
import Inter600NormalTrueType from "./inter-600-normal.ttf";
import Inter700NormalTrueType from "./inter-700-normal.ttf";
import Inter800NormalTrueType from "./inter-800-normal.ttf";
import Inter900NormalTrueType from "./inter-900-normal.ttf";

export default css`
  @font-face {
    font-family: "Inter";
    src: url(${Inter100NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 100;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter200NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 200;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter300NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 300;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter400NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter500NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter600NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter700NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter800NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 800;
  }

  @font-face {
    font-family: "Inter";
    src: url(${Inter900NormalTrueType}) format("truetype");
    font-style: normal;
    font-weight: 900;
  }
`;
